module.exports = __webpack_public_path__ + "static/media/positioning-01.ae1b1487.png";